import * as React from 'react';

import { createIcon } from '../Icon';
export const PowerIcon = createIcon(
  <React.Fragment>
    <path d="M18.36 6.64a9 9 0 1 1-12.73 0" />
    <line x1={12} x2={12} y1={2} y2={12} />
  </React.Fragment>,
  'PowerIcon'
);
